<template>
  <div>
    <!-- 未报名 -->
    <NotRegistered :activityInfo="activityAllInfo.activityInfo" :isLogin="activityAllInfo.isLogin" :buttonText="buttonText" v-if="isShowNotRegistered"/>
    <!-- 已报名，提交作文未开始 -->
    <!-- <RegisteredToStart :activityInfo="activityAllInfo.activityInfo" v-if="isShowRegisteredToStart"/> -->
    <!-- 待提交作文 -->
    <ToSubmit
      :activityInfo="activityAllInfo.activityInfo"
      :topicInfo="activityAllInfo.topicInfo"
      :isShowToSubmit="isShowToSubmit"
      :isShowRegisteredToStart="isShowRegisteredToStart"
      v-if="isShowRegisteredToStart || isShowToSubmit"
    />
    <!-- 审核及审核通过 -->
    <Result
      :activityInfo="activityAllInfo.activityInfo"
      :topicInfo="activityAllInfo.topicInfo"
      :personalArtical="activityAllInfo.personalArtical"
      :cityInfo="cityInfo" v-if="isResult"
      :isAuditing="isAuditing"
      :isAuditPass="isAuditPass"
    />
    <!-- 征稿期结束 --><!-- 复选 --><!-- 决胜 -->
    <zwPeriod
      :activityInfo="activityAllInfo.activityInfo"
      v-if="isFinal"
    />
  </div>
</template>
<script>
import NotRegistered from './notRegistered'
// import RegisteredToStart from './registeredToStart'
import ToSubmit from './toSubmit'
import Result from './result/index'
import zwPeriod from './zwPeriod'

export default {
  name: 'process',
  components: {
    NotRegistered,
    // RegisteredToStart,
    ToSubmit,
    // Submited,
    Result,
    zwPeriod
  },
  props: {
    activityAllInfo: {
      type: Object,
      required: true
    },
    topicInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    personalArtical: {
      type: Object,
      default() {
        return {}
      }
    },
    cityInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    isLogin: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    // apply_status-用户报名状态 0 未报名  1 已报名；
    // activity_status-活动状态 0 报名 1 上传作文 2 征稿结束 3 复选名单完成 4 决胜名单完成；
    // submit_status-用户征文提交状态 0 未提交 1 已提交
    // 未报名
    isShowNotRegistered() {
      return !this.activityAllInfo.isLogin || +this.activityAllInfo.activityInfo.apply_status === 0
    },
    buttonText() {
      const { activity_status } = this.activityAllInfo.activityInfo
      return activity_status < 2 ? '立即报名' : (!this.activityAllInfo.isLogin ? '登录' : '立即报名')
    },
    // 已报名、未开启提交作文
    isShowRegisteredToStart() {
      const { apply_status, activity_status } = this.activityAllInfo.activityInfo
      return +apply_status === 1 && +activity_status === 0
    },
    // 已报名、已开启上传作文、未提交作文
    isShowToSubmit() {
      const { apply_status, activity_status, submit_status } = this.activityAllInfo.activityInfo
      return +apply_status === 1 && +activity_status === 1 && +submit_status === 0
    },
    // 审核中 文章状态 process_status 0 AI待审核 1 ai审核不通过 2 初选中 3 止步初选 4 进入复选
    isAuditing() {
      const { submit_status, process_status } = this.activityAllInfo.activityInfo
      return +submit_status === 1 && +process_status === 0
    },
    // 审核中或者初选以后
    isResult() {
      const { process_status, activity_status } = this.activityAllInfo.activityInfo
      return (this.isAuditing || +process_status >= 2) && +activity_status <= 1
    },
    isAuditPass() {
      const { process_status } = this.activityAllInfo.activityInfo
      return +process_status >= 2
    },
    // 征稿期结束 +复选 +决选
    isFinal() {
      const { activity_status, apply_status } = this.activityAllInfo.activityInfo
      return +apply_status === 1 && [2, 3, 4].includes(activity_status)
      // return true
    }
  }
}
</script>
